// extracted by mini-css-extract-plugin
export var borderRadius = "_6p-4";
export var large = "_6p-3";
export var logoContainer = "_6p-0";
export var nameLogo = "_6p-2";
export var small = "_6p-1";